import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/tools/templates/page';

export const Route = createFileRoute('/_app/settings/tools/templates/')({
  component: Page,
});
